import { useEffect, useState } from 'react';

import { useTabs } from '@/domains/productDiscovery/ProductPage/hooks/useTabs';

type UseExpandedDescriptionReturn = [
  { hasOverflow: boolean; isExpanded: boolean },
  onExpandToggle: () => void,
  goToDescription: () => void,
];

export function useExpandedDescription<Top extends HTMLElement>(
  description: string,
  title: string | undefined,
  topRef: React.RefObject<Top>,
): UseExpandedDescriptionReturn {
  const { goToDescription } = useTabs();
  const [isExpanded, setExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(true);

  useEffect(() => {
    const height = window.innerHeight / 4;
    const descriptionHeight =
      topRef.current?.getBoundingClientRect().height || 0;
    const isTruncated = descriptionHeight > height;
    setHasOverflow(isTruncated);
    setExpanded(!isTruncated);
  }, [description, topRef]);

  const onExpandToggle = () => {
    setExpanded(!isExpanded);
  };

  return [
    {
      isExpanded,
      hasOverflow,
    },
    onExpandToggle,
    goToDescription,
  ];
}
